import { render } from "./marketplaceActivation.vue?vue&type=template&id=bc8c3bc8&scoped=true&ts=true"
import script from "./marketplaceActivation.vue?vue&type=script&lang=ts"
export * from "./marketplaceActivation.vue?vue&type=script&lang=ts"

import "./marketplaceActivation.vue?vue&type=style&index=0&id=bc8c3bc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc8c3bc8"]])

export default __exports__